module.exports = __webpack_public_path__ + "static/media/201A-1301A.a8af3903.png";